import calculateEllipseStatistics from './calculateEllipseStatistics.js';
import pointInEllipse from './pointInEllipse.js';

// Named
export { calculateEllipseStatistics, pointInEllipse };

// Default
export default {
  calculateEllipseStatistics,
  pointInEllipse,
};
